import(/* webpackMode: "eager" */ "/app/askfinz.com/components/marketing/animations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndexCoverageLive"] */ "/app/askfinz.com/components/marketing/index-coverage-live.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndexQualityLive"] */ "/app/askfinz.com/components/marketing/index-quality-live.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IndexStagesDiagram"] */ "/app/askfinz.com/components/marketing/index-stages-diagram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NodeFleetLive"] */ "/app/askfinz.com/components/marketing/node-fleet-live.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnDemandIndexingLive"] */ "/app/askfinz.com/components/marketing/on-demand-indexing-live.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PoweredByIndexing"] */ "/app/askfinz.com/components/marketing/powered-by-indexing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafetyStatsLive"] */ "/app/askfinz.com/components/marketing/safety-stats-live.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScaleEfficiency"] */ "/app/askfinz.com/components/marketing/scale-efficiency.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScaleIndexDepth"] */ "/app/askfinz.com/components/marketing/scale-index-depth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchPerformanceLive"] */ "/app/askfinz.com/components/marketing/search-performance-live.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SourcesMarquee"] */ "/app/askfinz.com/components/marketing/sources-marquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Spotlight"] */ "/app/askfinz.com/components/marketing/spotlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StorageEfficiencyLive"] */ "/app/askfinz.com/components/marketing/storage-efficiency-live.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StorageScaleExplorer"] */ "/app/askfinz.com/components/marketing/storage-scale-explorer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StorageTiersDiagram"] */ "/app/askfinz.com/components/marketing/storage-tiers-diagram.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebIndexHeroStats"] */ "/app/askfinz.com/components/marketing/web-index-hero-stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebIndexPipeline"] */ "/app/askfinz.com/components/marketing/web-index-sections.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
